import theme from '@/theme';
import styled from '@emotion/styled';

const StyledTableHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 20px;
    height: 72px;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.black[300]};
`;

const StyledTitle = styled.span`
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary.main};
`;

interface Props {
    title: string;
    actions?: React.ReactNode;
}

export const TableHeader = ({ title, actions }: Props) => {
    return (
        <StyledTableHeader>
            <StyledTitle>{title}</StyledTitle>
            {actions}
        </StyledTableHeader>
    );
};
